export interface ForemanTask {
  foremanTaskID: string;
  taskDescription: string;
  isFavorite: boolean;
  bActive: boolean;
}
